import { Subject } from 'rxjs'

export class EventUtils {
  static openSubject: Subject<any>
  static closeSubject: Subject<any>
  static errorSubject: Subject<any>

  static newInstance() {
    if (!this.openSubject) {
      this.openSubject = new Subject()
    }
    if (!this.closeSubject) {
      this.closeSubject = new Subject()
    }
    if (!this.errorSubject) {
      this.errorSubject = new Subject()
    }
  }

  static subscribeWebview(open, close) {
    this.openSubject.throttleTime(1000).subscribe(open)
    this.closeSubject.throttleTime(1000).subscribe(close)
  }
  static subscribeErrorLabel(subscription) {
    this.errorSubject.throttleTime(2000).subscribe(subscription)
  }

  static OpenWebview(object?) {
    if (!this.openSubject.closed) {
      this.openSubject.next(object)
    }
  }

  static CloseWebview(object?) {
    if (!this.closeSubject.closed) {
      this.closeSubject.next(object)
    }
  }

  static ShowError(object?) {
    if (!this.errorSubject.closed) {
      this.errorSubject.next(object)
    }
  }

  static err(object?) {
    this.openSubject.error(object)
    this.closeSubject.error(object)
    this.errorSubject.error(object)
  }

  static complete() {
    this.openSubject.complete()
    this.closeSubject.complete()
    this.errorSubject.complete()
  }

  static unsubscribe() {
    try {
      this.openSubject.unsubscribe()
      this.closeSubject.unsubscribe()
      this.errorSubject.unsubscribe()
  } catch (e) {
      console.error(e)
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/utils/EventUtils.ts